import { readonly } from "vue";
import { IStore } from "@/interfaces/state.interface";

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const store: IStore = { state: readonly(state), mutations, getters, actions };

export default store;